import { render, staticRenderFns } from "./AttributeFilter.vue?vue&type=template&id=3396bf38&scoped=true"
import script from "./AttributeFilter.vue?vue&type=script&lang=ts"
export * from "./AttributeFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3396bf38",
  null
  
)

export default component.exports